import { useMemo } from "react";
import ChatBox from "components/ChatBox";
import Loader from "components/Loader";
import { ListeningStatus } from "shared/config/constants";

import UserBlue from "../../assets/images/user.svg"
import "./styles.scss"
import { useIsMobile } from "shared/hooks/useIsMobile";
import { languageService } from 'services';
import { useAppSettings } from 'shared/context/AppSettingsContext';

function TranscriptSingle({ conversation, currentMessage, listeningStatus }) {
    const isMobile = useIsMobile();
    const appSettings = useAppSettings();

    const lastMessage = useMemo(() => {
        const conversationLength = conversation.length;
        if (conversationLength === 0) return null;

        return conversation[conversationLength - 1];
    }, [conversation]);

    const userSelectedSourceLanguage = useMemo(() => languageService.getLocale(appSettings.settings.sourceLanguage, appSettings.settings.sourceDialect), [appSettings.settings.sourceLanguage, appSettings.settings.sourceDialect]);

    const getMessage = () => {
        switch (listeningStatus) {
            case ListeningStatus.StartingToListen: return <span className="h1">Getting Started</span>;
            case ListeningStatus.Listening: return <span className="h1">Listening</span>;
            default: return <></>
        }
    }

    if (currentMessage.text) {
        return (
            <div className={`d-flex single flex-row align-items-start ${isMobile && userSelectedSourceLanguage.code === currentMessage.language ? 'reverse' : ''}`}>
                <ChatBox
                    type={'transparent'}
                    currentMessage={currentMessage.text}
                    targetLanguage={listeningStatus === ListeningStatus.Processing && (
                        <h4><i className="translation_loading">Translating</i></h4>
                    )}
                    sourceLanguageTranscriptionDir={currentMessage.sourceLanguageTranscriptionDir}
                    reverse={isMobile && userSelectedSourceLanguage.code === currentMessage.language}
                />
            </div>
        );
    }

    if (lastMessage) {
        return (
            <div className={`d-flex single flex-row align-items-start  ${isMobile && userSelectedSourceLanguage.code === lastMessage.sourceLanguageCode ? 'reverse' : ''}`}>
                <ChatBox
                    type={'transparent'}
                    currentMessage={lastMessage.sourceLanguage}
                    targetLanguage={lastMessage.targetLanguage}
                    sourceLanguageTranscriptionDir={lastMessage.sourceLanguageTranscriptionDir}
                    targetLanguageTranscriptionDir={lastMessage.targetLanguageTranscriptionDir}
                    reverse={isMobile && userSelectedSourceLanguage.code === lastMessage.sourceLanguageCode}
                    errorMessage={lastMessage.errorMessage}
                />
            </div>
        );
    }

    return (
        <div className="d-flex flex-row align-items-start gap-4 loading">
            {listeningStatus !== ListeningStatus.Idle && <img src={UserBlue} alt="user" className="user-img" />}
            <div className="d-flex gap-2 align-items-center">
                {getMessage()}
                {listeningStatus !== ListeningStatus.Idle && <Loader boxClassName="highlight-bg" animate={listeningStatus === ListeningStatus.Listening} />}
            </div>
        </div>
    );
}

export default TranscriptSingle;
